// frontend/src/api/vendor.api.js
import apiClient from './client.js';

export const getVendors = async (params = {}) => {
  const response = await apiClient.get('/vendors', { params });
  return response.data.data;
};

export const getVendor = async (id) => {
  const response = await apiClient.get(`/vendors/${id}`);
  return response.data.data;
};

export const updateVendor = async (id, data) => {
  const response = await apiClient.put(`/vendors/${id}`, data);
  return response.data.data;
};

export const verifyVendor = async (id) => {
  const response = await apiClient.post(`/vendors/${id}/verify`);
  return response.data.data;
};

export const restoreVendor = async (id) => {
  const response = await apiClient.post(`/vendors/${id}/restore`);
  return response.data.data;
};

export const revokeVendor = async (id) => {
  const response = await apiClient.post(`/vendors/${id}/revoke`);
  return response.data.data;
};

export const deleteVendor = async (id) => {
  const response = await apiClient.delete(`/vendors/${id}`);
  return response.data.data;
};

export const uploadVendorDocument = async (vendorId, formData) => {
  const response = await apiClient.post(`/vendors/${vendorId}/documents`, formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
  });
  return response.data.data;
};

export const getVendorDocumentUrl = async (vendorId, docId) => {
  const response = await apiClient.get(`/vendors/${vendorId}/documents/${docId}`);
  return response.data.data;
};
